<div class="main-container" fxFlexAlign="center center" [ngClass]="data.dialogClass">
  @if (data.dialogClass === 'modern' && data.iconName) {
    <div class="icon-bg" [ngClass]="data.iconBgColor">
      <mat-icon [svgIcon]="data.iconName"></mat-icon>
    </div>
  }
  @if (data.title) {
    <h2 class="title">{{ data.title }}</h2>
  }
  @if (data.dialogClass !== 'modern' && data.iconName) {
    <mat-icon [svgIcon]="data.iconName"></mat-icon>
  }
  <div>
    <p>
      {{ data.greeting }}
      @if (data.infoMessage) {
        <br />
      }
      {{ data.infoMessage }}
      @if (data.contactMessage) {
        <br />
        <br />
      }
      <span [innerHtml]="data.contactMessage"></span>
    </p>
  </div>
  <button (click)="onActionBtn()" class="close-button" aria-label="Close alert" data-close data-test="close-button">
    {{ data.action.name | titlecase }}
  </button>
</div>
